import React from 'react';
import { theme, Page, PageHeaderLogo, PageContainerVCenter, PageBoxContent } from '../../ui';
import SupportLink from '../../features/auth/components/SupportLink';
import TestEnvironmentWarning from '../TestEnvironmentWarning';
import GiftForm from './GiftForm';

const ReclaimGift = () => {
  return (
    <Page backgroundColor={theme.colors.PRIMARY} fullheight={true}>
      <PageHeaderLogo />
      <PageContainerVCenter>
        <PageBoxContent>
          <TestEnvironmentWarning />
          <GiftForm />
          <SupportLink />
        </PageBoxContent>
      </PageContainerVCenter>
    </Page>
  );
};

export default ReclaimGift;
